<template>
  <div id="AmazonPayButton"></div>
</template>

<script>
const AMAZON_CHECKOUT = 'https://static-fe.payments-amazon.com/checkout.js'
export default {
  name: 'AmazonPayButton',
  props: {
    /**
     * payload( 2. Generate ~. と 3. Sign the payload 済みのデータ)
     */
    render: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  mounted() {
    if (this.render) {
      this.loadScript(this.setRender)
    } else {
      console.error('Amazon Pay ボタンをレンダリングできません。')
    }
  },
  methods: {
    /**
     * 1. Add the Amazon Pay script
     * https://amazonpaycheckoutintegrationguide.s3.amazonaws.com/amazon-pay-checkout/add-the-amazon-pay-button.html#1-add-the-amazon-pay-script
     * onload 完了したら、ボタンをレンダリング
     */
    loadScript( handler ) {
      let script = document.createElement('script')
      script.src = AMAZON_CHECKOUT
      script.async = true
      script.onload = () => { handler() }
      document.head.appendChild(script)
    },
    /**
     * 4. Render the button
     * https://amazonpaycheckoutintegrationguide.s3.amazonaws.com/amazon-pay-checkout/add-the-amazon-pay-button.html#4-render-the-button
     */
    setRender() {
      amazon.Pay.renderButton('#AmazonPayButton', {
        merchantId: this.render.merchantId,
        ledgerCurrency: this.render.currencyCode,
        sandbox: this.render.sandbox.toLowerCase() == 'true' ? true : false,
        checkoutLanguage: this.render.checkoutLanguage,
        productType: this.render.productType,
        placement: this.render.placement,
        createCheckoutSessionConfig: {
          payloadJSON: this.render.payload,
          signature: this.render.signature,
          publicKeyId: this.render.publicKeyId
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#AmazonPayButton {
  width: 100% !important;
  height: 53px !important;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/AmazonPayButton.vue